module.exports = {
  fnAjaxRequest: function(
    ajaxURL,
    ajaxReqMethod,
    ajaxReqData,
    onSuccess,
    onError
  ) {
    try {
      $.ajax({
        type: ajaxReqMethod,
        url: ajaxURL,
        data: ajaxReqData,
        success: onSuccess,
        error: onError,
        contentType: 'application/x-www-form-urlencoded'
      });
    } catch (ex) {
      // console.log('a')
    }
  },

  ShowVSAlert: function(type, message) {
    var alertType = type || 'info';
    var alertMessage = message || '';
    $('.warning-icon').addClass('hide');
    $('.error-icon').addClass('hide');
    $('.success-icon').addClass('hide');
    if (alertType == 'info') {
      $('.warning-icon').removeClass('hide');
    } else if (alertType == 'error') {
      $('.error-icon').removeClass('hide');
    } else {
      $('.success-icon').removeClass('hide');
    }
    $('.alert-body .alert-text').html(alertMessage);
    $('.vsCodeAlert').fadeIn(function() {
      setTimeout(() => {
        $('.vsCodeAlert').fadeOut();
      }, 3000);
    });
  }
};
